import { ExportTableDialog, TableSettingsDialog } from "@/ds";
import { FinanceiroObrasCards } from "./components/financeiro-obras-cards-view";
import { FinanceiroObrasLista } from "./components/financeiro-obras-lista-view";
import { FinanceiroObrasToolbar } from "./components/financeiro-obras-toolbar";
import { FinanceiroObraDetailDialog } from "./fichas";
import { FINANCEIRO_COLUMN_LABELS, FINANCEIRO_MAIN_COLUMNS } from "./financeiro-obras.constants";
import styles from "./financeiro-obras-screen.module.scss";
import type {
  FinanceiroObrasColumnKey,
  FinanceiroObrasScreenViewModel,
} from "./types-financeiro-obras";

/**
 * Financeiro › Obras (HU 2670) — consulta somente leitura das obras em Lista (DataTable) ou
 * Cards (por status financeiro), com busca, filtros, filtros salvos e Configurações da Tabela.
 * Lista e Cards compartilham busca, filtros e ordenação. O privilégio `hub.financeiro:visualizar-painel` é
 * aplicado pela API: sem ele a tela mostra "Acesso não autorizado" a partir do 403.
 *
 * A lupa da Lista abre o detalhamento financeiro da obra (HU 2679), com o acesso às fichas.
 */
export function FinanceiroObrasScreenView({
  isMobile,
  view,
  changeView,
  search,
  changeSearch,
  filters,
  sort,
  appliedSort,
  changeSort,
  settings,
  changeListResult,
  statusOptions,
  tipoOptions,
  isTipoDisabled,
  changeStatus,
  changeTipo,
  filterColumns,
  panelValue,
  panelSavedFilters,
  applyPanel,
  saveFilter,
  applySavedFilter,
  deleteSavedFilter,
  exportView,
  notifySettingsApplied,
  clearSearch,
  clearFilters,
  detalheObra,
  abrirDetalhe,
  fecharDetalhe,
}: FinanceiroObrasScreenViewModel) {
  const containerClassName = `${styles.container} ${styles.containerLista}${view === "lista" ? ` ${styles.containerTabela}` : ""}`;

  return (
    <section className={containerClassName} data-testid="financeiro-obras-screen">
      <FinanceiroObrasToolbar
        isMobile={isMobile}
        view={view}
        onViewChange={changeView}
        search={search}
        onSearchChange={changeSearch}
        filters={filters}
        statusOptions={statusOptions}
        tipoOptions={tipoOptions}
        isTipoDisabled={isTipoDisabled}
        onStatusChange={changeStatus}
        onTipoChange={changeTipo}
        filterDefinitions={filterColumns}
        filterValue={panelValue}
        onFilterChange={applyPanel}
        savedFilters={panelSavedFilters}
        onSaveFilter={saveFilter}
        onDeleteSavedFilter={deleteSavedFilter}
        onApplySavedFilter={applySavedFilter}
        onExport={exportView.open}
        onOpenSettings={settings.dialog.open}
      />

      {exportView.isOpen ? (
        <ExportTableDialog
          listName="obras do Financeiro"
          variant="figma"
          isExporting={exportView.isExporting}
          onExport={exportView.run}
          onCancel={exportView.close}
        />
      ) : null}

      <TableSettingsDialog<FinanceiroObrasColumnKey>
        dialog={settings.dialog}
        columnLabels={FINANCEIRO_COLUMN_LABELS}
        mainColumns={FINANCEIRO_MAIN_COLUMNS}
        showColumnsSection={settings.showColumnsSection}
        testId="financeiro-obras-table-settings"
        onApplied={notifySettingsApplied}
      />

      {detalheObra ? (
        <FinanceiroObraDetailDialog obra={detalheObra} onClose={fecharDetalhe} />
      ) : null}

      <div className={styles.content}>
        {view === "lista" ? (
          <FinanceiroObrasLista
            search={search}
            filters={filters}
            sort={sort}
            onSort={changeSort}
            settings={settings}
            isMobile={isMobile}
            onResult={changeListResult}
            onDetail={abrirDetalhe}
            onClearSearch={clearSearch}
            onClearFilters={clearFilters}
          />
        ) : (
          <FinanceiroObrasCards
            isMobile={isMobile}
            search={search}
            filters={filters}
            sort={appliedSort}
            onClearSearch={clearSearch}
            onClearFilters={clearFilters}
          />
        )}
      </div>
    </section>
  );
}
